import React, { useState, useRef, useEffect } from "react";
import { Simulation } from "../../hooks/simulationData";

// Value states set in the component
export const RangeSlider = ({
  id,
  customClasses,
  name,
  minValue,
  maxValue,
  step,
  defaultValue,
  minValueLabel,
  maxValueLabel,
  rataDefaultValueLabel,
  onChange,
}) => {
  const [value, setValue] = useState(defaultValue);
  const [inputWidth, setInputWidth] = useState();

  const inputRef = useRef();

  useEffect(() => {
    setInputWidth(inputRef.current.offsetWidth);
  }, []);

  function handleRangeOnChange(event) {
    const value = event.target.value;
    setValue(value);
    if (onChange) {
      onChange(event);
    }
  }

  function calculateRangeTooltipMargin() {
    const rataPerc = Simulation.get("rataPerc") || 0;

    let marginValue = 14;

    if (maxValue - minValue != 0) {
      marginValue =
        (((minValue == 0 ? rataPerc : value) - minValue) /
          (maxValue - minValue)) *
          (inputWidth - 14 - 14) +
        14;
    }

    return `${marginValue}px`;
  }

  const formatTooltipValue = (value) => {
    return new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(rataDefaultValueLabel || value);
  };

  return (
    <div className={["range-slider", customClasses].join(" ")}>
      <div className="range-tooltip-container">
        <div
          className="range-tooltip"
          style={{
            left: calculateRangeTooltipMargin(),
          }}
        >
          {formatTooltipValue(value)}
        </div>
      </div>
      <input
        type="range"
        id={id}
        name={name}
        min={minValue}
        max={maxValue}
        step={step}
        value={value}
        ref={inputRef}
        onChange={(event) => handleRangeOnChange(event)}
      />
      <div className="range-caption">
        <span>{minValueLabel} €</span>
        <span>{maxValueLabel} €</span>
      </div>
    </div>
  );
};
